module.exports = __webpack_public_path__ + "static/modal-action-dont-8b0464d2c46768331e9c904f18ec7783.png";